import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { TBillsState } from '../../types'
import { moneyFlowService } from '../../../services'
import { parseHttpError } from '../../utils'
import { parseBills } from './utils'
import { selectors } from './selectors'
import { TApiBill } from '../../../services/moneyFlow/types'
import { billsAdapter } from './adapter'

const name = 'bills'

const initialState: TBillsState = {
    ...billsAdapter.getInitialState(),
    isFetching: false
}

const fetch = createAsyncThunk(
    `${name}/fetch`,
    async () => {
        return parseBills(await moneyFlowService.fetchBills())
    },
    {
        serializeError: parseHttpError
    }
)

const create = createAsyncThunk(
    `${name}/create`,
    async (bill: TApiBill) => {
        return await moneyFlowService.createBills(bill)
    },
    {
        serializeError: parseHttpError
    }
)

const slice = createSlice({
    name,
    initialState,
    reducers: {},
    extraReducers: (builder) =>
        builder
            .addCase(fetch.pending, (state) => {
                state.isFetching = true
                state.fetchError = undefined
            })
            .addCase(fetch.fulfilled, (state, action) => {
                state.isFetching = false
                billsAdapter.setAll(state, action.payload)
            })
            .addCase(fetch.rejected, (state, action) => {
                state.isFetching = false
                state.fetchError = action.error
            })
})

export const bills = {
    name: slice.name,
    actions: {
        fetch,
        create,
    },
    reducer: slice.reducer,
    selectors,
}